module.exports = __webpack_public_path__ + "media/images/logo_vdq-7a147c7aac38a2fa1377c57bd9c99ed4.png";